import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';

const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function UnderpaidInvoiceDecision({ txn, busy, decide }) {
  const h = txn.invoice_hint;
  if (!h || !h.id) return null;
  const id = txn.basiq_id;
  const btn = (label, action, style, testid) => (
    <button onClick={() => decide(txn, action)} disabled={!!busy} data-testid={`${testid}-${id}`}
      className="text-xs px-2 py-0.5 rounded font-title" style={{ ...style, opacity: busy ? 0.6 : 1 }}>
      {busy === `decide-${action}-${id}` ? <Loader2 className="animate-spin inline" size={11} /> : label}
    </button>
  );
  return (
    <div className="mt-1 rounded px-2 py-1.5 text-xs" style={{ background: '#fff4e0', border: '1px solid #f0c674', color: '#5a3d00' }} data-testid={`banking-underpaid-${id}`}>
      <div className="flex items-center gap-1 font-title">
        <AlertTriangle size={12} /> Short-paid invoice {h.number} by {money(h.short_by)}
        <span className="font-normal" style={{ color: '#8a5a00' }}>({money(h.total)} invoiced{h.member ? `, ${h.member}` : ''})</span>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-1">
        {btn('Accept as paid', 'accept', { background: '#1a7f37', color: 'white' }, 'banking-underpaid-accept')}
        {btn(h.asked_at ? `Balance asked ${String(h.asked_at).slice(0, 10)} · ask again` : 'Ask for the balance', 'ask', { background: 'var(--navy)', color: 'var(--cream)' }, 'banking-underpaid-ask')}
        {btn('Not this invoice', 'dismiss', { background: 'white', border: '1px solid rgba(0,0,0,0.2)', color: 'var(--ink)' }, 'banking-underpaid-dismiss')}
      </div>
    </div>
  );
}

export function LapsedPaymentDecision({ txn, busy, decide }) {
  const h = txn.lapse_hint;
  if (!h || !h.user_id) return null;
  const id = txn.basiq_id;
  const btn = (label, action, style, testid) => (
    <button onClick={() => decide(txn, action)} disabled={!!busy} data-testid={`${testid}-${id}`}
      className="text-xs px-2 py-0.5 rounded font-title" style={{ ...style, opacity: busy ? 0.6 : 1 }}>
      {busy === `lapse-${action}-${id}` ? <Loader2 className="animate-spin inline" size={11} /> : label}
    </button>
  );
  return (
    <div className="mt-1 rounded px-2 py-1.5 text-xs" style={{ background: '#fdecea', border: '1px solid #e8a39a', color: '#5a1a12' }} data-testid={`banking-lapsed-${id}`}>
      <div className="flex items-center gap-1 font-title">
        <AlertTriangle size={12} /> Renewal from lapsed member {h.member}
        <span className="font-normal" style={{ color: '#8a1f11' }}>(year ended {h.expired || '—'}, grace closed {h.grace_until || '—'}{h.invoice_number ? `, ${h.invoice_number}` : ''})</span>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-1">
        {btn('Re-admit & apply payment', 'readmit', { background: '#1a7f37', color: 'white' }, 'banking-lapsed-readmit')}
        {btn('Refund / not a renewal', 'dismiss', { background: 'white', border: '1px solid rgba(0,0,0,0.2)', color: 'var(--ink)' }, 'banking-lapsed-dismiss')}
      </div>
    </div>
  );
}
